import type { ReactNode } from "react";

export function Status({ tone, children }: { tone: "success" | "warning" | "danger" | "muted"; children: ReactNode }) {
  return <span className={`status status-${tone}`}><i aria-hidden="true" />{children}</span>;
}

export function PageState({ title, detail, action }: { title: string; detail: string; action?: ReactNode }) {
  return <div className="page-state" role="status"><strong>{title}</strong><p>{detail}</p>{action}</div>;
}
